
import { NavLink } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useState, useEffect } from "react";
import { useNotifications } from "../context/NotificationContext";
import NotificationDropdown from "./NotificationDropdown";

export default function TopNavbar({ toggleSidebar }) {
  const { user, logout } = useAuth();
  const { notifications } = useNotifications();

  const [openProfile, setOpenProfile] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "dark";
    return localStorage.getItem("app-theme") || "dark";
  });

  const handleLogout = async () => {
    await logout();
  };

  useEffect(() => {
    const close = () => setOpenNotification(false);

    if (openNotification) {
      window.addEventListener("click", close);
    }

    return () => window.removeEventListener("click", close);
  }, [openNotification]);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    document.documentElement.style.colorScheme = theme;
    localStorage.setItem("app-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "dark" ? "light" : "dark"));
  };

  return (
    <nav className="flex items-center border-b px-4 py-3 shadow-md" style={{ backgroundColor: 'var(--surface)', color: 'var(--text)', borderColor: 'var(--border)' }}>

      {/* ✅ Mobile Menu Button */}
      <button
        onClick={toggleSidebar}
        className="mr-3 rounded-xl border px-2.5 py-1.5 text-xl md:hidden"
        style={{ borderColor: 'var(--border)', backgroundColor: 'var(--surface-soft)', color: 'var(--text)' }}
        aria-label="Toggle menu"
      >
        ☰
      </button>

      {/* Logo */}
      <h2 className="mr-6 text-xl font-semibold text-indigo-400">
        Atithi Dhaba
      </h2>

      {/* Menu */}
      <div className="hidden md:flex gap-4">
        

        {(user?.role === "admin" || user?.role === "superadmin") && (
          <NavLink to="/admin" className="text-slate-300 transition hover:text-indigo-400">
            Admin
          </NavLink>
        )}
      </div>

      {/* Right Section */}
      {user && (
        <div className="ml-auto flex items-center gap-4 relative">
          <p>Welcome: {user?.firstname} {user?.lastname}</p>
          {/* 🔔 Notification */}
          <div className="relative cursor-pointer">
            <span
              onClick={(e) => {
                e.stopPropagation();
                setOpenNotification(!openNotification);
              }}
              className="text-xl text-slate-100"
            >
              🔔
            </span>

            <span className="absolute -top-1 -right-1 rounded-full bg-rose-500 px-1.5 text-[10px] font-semibold text-white">
              {notifications.length}
            </span>

            {openNotification && (
              <NotificationDropdown notifications={notifications} />
            )}
          </div>

          <button
            onClick={toggleTheme}
            className="rounded-full border px-3 py-2 text-sm transition"
            style={{ borderColor: 'var(--border)', backgroundColor: 'var(--surface-soft)', color: 'var(--text)' }}
            aria-label="Toggle theme"
          >
            {theme === "dark" ? "☀️" : "🌙"}
          </button>

          {/* Avatar */}
          <div
            onClick={() => setOpenProfile(!openProfile)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-indigo-500 text-sm font-semibold text-white"
          >
            {user?.role?.charAt(0).toUpperCase()}
          </div>

          {/* Dropdown */}
          {openProfile && (
            <div className="absolute right-0 top-12 w-44 rounded-2xl border py-2 shadow-xl" style={{ borderColor: 'var(--border)', backgroundColor: 'var(--surface)' }}>
              <div className="border-b px-4 py-2 text-sm" style={{ borderColor: 'var(--border)', color: 'var(--text-muted)' }}>
                {user?.role}
              </div>

              <button className="w-full px-4 py-2 text-left" style={{ color: 'var(--text)' }} onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--surface-soft)'} onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}>
                My Profile
              </button>

              <button className="w-full px-4 py-2 text-left" style={{ color: 'var(--text)' }} onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--surface-soft)'} onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}>
                Settings
              </button>

              <button
                onClick={handleLogout}
                className="w-full px-4 py-2 text-left text-sm"
                style={{ color: 'var(--text)' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = 'var(--surface-soft)'}
                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      )}
    </nav>
  );
}
